import { Control } from '@Common/Controls/Controls';
import { dialog, IDialogParameters } from '@Common/Controls/Dialog';

type ValueControl<TValue> = Control & { getValue(): TValue };

export function valueDialog<TValue>(setting: IDialogParameters & { control: ValueControl<TValue> }): Promise<TValue | undefined> {
    const { control, ...params } = setting;
    const dlg = dialog(params);
    dlg.wrap(control);
    return new Promise<TValue | undefined>(resolve => {
        dlg.ok(() => resolve(control.getValue()));
        dlg.cancel(() => resolve(undefined));
        dlg.onClose(() => resolve(undefined));
    });
}
